import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', () => {
    let decoratedImages = document.querySelector(".js-decorated-images");

    if (!decoratedImages) {
        return; // Stop execution on pages without the decorated images module.
    }

    gsap.registerPlugin(ScrollTrigger);

    // Animation for the decoration image
    gsap.fromTo('.l-decorated-images__decoration',
        {
            // Initial state - positioned off-screen to the left
            x: '-100vw',
            opacity: 0
        },
        {
            // Final state - animate to original position
            x: 0,
            opacity: 1,
            duration: 1,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: '.layout--decorated-images',
                start: 'top 80%', // Animation starts when top of section is 80% from top of viewport
                end: 'top 20%',   // Animation ends when top of section is 20% from top of viewport
                toggleActions: 'play none none reverse', // play on enter, reverse on leave
                // markers: true, // Uncomment for debugging
            }
        }
    );
});
